export enum FORM_FIELD_VALIDATION_STATUS {
  VALIDATION_NOT_REQUIRED,
  INITIALIZE,
  VALID,
  NOT_VALID,
}

export enum USER_ROLE_TYPE {
  PROVIDER = "provider",
  CAREGIVER = "caregiver",
  RESIDENT_MANAGER = "resident manager",
  FAMILY_MEMBER = "family member",
}

export enum RESOURCE_LINK_TYPE {
  HOME_CAREGIVER = "homeCaregiver",
  RESIDENT_FAMILY = "residentFamily",
}
